<section class="mod-page" data-module="workflow">
  <header class="page-header">
    <div>
      <p class="eyebrow">Workflow actions</p>
      <h1>Stage controls</h1>
    </div>
  </header>

  @if (message()) {
    <p class="toast">{{ message() }}</p>
  }

  <div class="grid-2">
    <section class="panel">
      <div class="queue-selector">
        <span>Queue · {{ queue().length }} case{{ queue().length === 1 ? '' : 's' }}</span>
        <button
          type="button"
          class="queue-trigger"
          [disabled]="!queue().length"
          [attr.aria-expanded]="queueOpen()"
          aria-haspopup="listbox"
          (click)="toggleQueue()"
        >
          @if (selected(); as current) {
            <span class="status-dot" [attr.data-status]="current.stage"></span>
            <span class="queue-trigger-copy">
              <strong>{{ current.trackingId }}</strong>
              <small>{{ current.subject }}</small>
            </span>
            <span class="status-chip" [attr.data-status]="current.stage">
              {{ statusLabel(current.stage) }}
            </span>
          } @else {
            <span class="queue-trigger-copy"><strong>Select a case</strong></span>
          }
          <span class="queue-chevron" [class.is-open]="queueOpen()" aria-hidden="true">⌄</span>
        </button>

        @if (queueOpen()) {
          <button class="queue-backdrop" type="button" aria-label="Close case queue" (click)="queueOpen.set(false)"></button>
          <div class="queue-menu" role="listbox" aria-label="Workflow cases">
            @for (item of queue(); track item.id) {
              <button
                type="button"
                class="queue-option"
                role="option"
                [class.is-selected]="selected()?.id === item.id"
                [attr.aria-selected]="selected()?.id === item.id"
                (click)="selectCase(item.id)"
              >
                <span class="status-dot" [attr.data-status]="item.stage"></span>
                <span class="queue-option-copy">
                  <strong>{{ item.trackingId }}</strong>
                  <small>{{ item.subject }}</small>
                </span>
                <span class="status-chip" [attr.data-status]="item.stage">
                  {{ statusLabel(item.stage) }}
                </span>
              </button>
            }
          </div>
        }
      </div>

      @if (selected(); as item) {
        <div class="form-grid">
          <article class="kpi">
            <span>Current Status</span>
            <strong style="font-size: 1.1rem">{{ item.stage }}</strong>
          </article>
          <article class="kpi">
            <span>Priority</span>
            <strong style="font-size: 1.1rem">{{ item.priority }}</strong>
          </article>
          <article class="kpi">
            <span>Subject</span>
            <strong style="font-size: 1.05rem">{{ item.subject }}</strong>
          </article>
          <article class="kpi">
            <span>Department</span>
            <strong style="font-size: 1.05rem">{{ item.department }}</strong>
          </article>
        </div>

        <label
          style="display: grid; gap: 0.35rem; margin-top: 1rem; font-size: 0.8rem; color: var(--ink-muted); font-weight: 600"
        >
          Comments
          <textarea
            class="field"
            rows="3"
            [ngModel]="comment()"
            (ngModelChange)="comment.set($event)"
            placeholder="Add workflow comment"
          ></textarea>
        </label>

        <div class="btn-row" style="margin-top: 0.85rem">
          @for (action of allowedActions(); track action) {
            <button
              type="button"
              class="btn primary"
              [class.danger]="action === 'Reject'"
              (click)="act(action)"
            >
              {{ action }}
            </button>
          } @empty {
            <p class="muted">No workflow actions available for your role ({{ role() }}).</p>
          }
        </div>
      }
    </section>

    <section class="panel workflow-panel">
      <div class="workflow-head">
        <div>
          <h2>Workflow timeline</h2>
        </div>
        <span class="progress-badge">{{ progressPercent() }}% complete</span>
      </div>

      <div class="workflow-progress" [style.--progress.%]="progressPercent()">
        <span class="track-line" aria-hidden="true"></span>
        <span class="progress-line" aria-hidden="true"></span>
        <ol class="workflow-stages">
          @for (stage of stages(); track stage.id; let index = $index) {
            <li [attr.data-state]="stageState(stage.id)">
              <span class="stage-dot" aria-hidden="true">
                @if (stageState(stage.id) === 'completed') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                } @else {
                  {{ index + 1 }}
                }
              </span>
              <div class="stage-copy">
                <div class="stage-title">
                  <strong>{{ stage.label }}</strong>
                  <span>{{ stageMessage(stage) }}</span>
                </div>
                <p>{{ stage.description }}</p>
                @if (stage.id === currentStageId()) {
                  <time>Last updated {{ selected()?.awaitingSince | date: 'd MMM y, HH:mm' }}</time>
                }
              </div>
            </li>
          }
        </ol>
      </div>

      <div class="activity-summary">
        <span>Latest activity</span>
        <strong>{{ selected()?.subject }}</strong>
        <p>
          {{ selected()?.trackingId }} · current status
          <b>{{ selected()?.stage }}</b>
        </p>
      </div>
    </section>
  </div>
</section>
